// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.login-lock-warning{\n\tmargin-top:30px;\n\t\n\tbackground-color:var(--rouge-fonce);\n\tcolor:white;\n\tpadding: 10px;\n\tborder-radius: 9px;\n}\n.disabled {\n&.btn.btn-primary , &.btn-primary.btn:hover, &.btn-primary.btn:focus {\n\t\tbackground-color:var(--fbc-light-gray);\n\t\tcolor:var(--fbc-secondary-text);\n\t\tcursor: not-allowed;\n}\n}\n\n", ""]);
// Exports
module.exports = exports;
